// import http from "./http";

// // GET Questions by Section (A, B, C)
// export const getSectionQuestions = async (section) => {
//   const res = await http.get(
//     `section_questions_api?action=list&section=${section}`
//   );
//   return res.data;
// };

// // IMPORT CSV
// export const importSectionQuestions = async (section, file) => {
//   const formData = new FormData();
//   formData.append("file", file);

//   const res = await http.post(
//     `section_questions_api?action=import&section=${section}`,
//     formData,
//     {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     }
//   );

//   return res.data;
// };

// // ADD SINGLE QUESTION (No Change API Structure)
// export const addSectionQuestion = async (section, question) => {
//   const res = await http.post(
//     `section_questions_api?action=add&section=${section}`,
//     {
//       question: question,
//     }
//   );

//   return res.data;
// };

// export const deleteSectionQuestion = async (section, id) => {
//   const res = await http.post(
//     `section_questions_api?action=delete&section=${section}&id=${id}`
//   );

//   return res.data;
// };

// export const updateSectionQuestion = async (section, data) => {
//   const res = await http.post(
//     `section_questions_api?action=edit&section=${section}`,
//     data
//   );
//   return res.data;
// };

import http from "./http";

/* ================= GET ================= */
export const getSectionQuestions = async (section) => {
  const res = await http.get(
    `section_questions_api?action=list&section=${section}`
  );
  return res.data;
};

/* ================= IMPORT CSV ================= */
export const importSectionQuestions = async (section, file) => {
  const formData = new FormData();
  formData.append("file", file);

  // 🔥 Only Section C uses different API
  if (section === "C") {
    const res = await http.post(
      `c_section_import`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return res.data;
  }

  // Section A & B
  const res = await http.post(
    `section_questions_api?action=import&section=${section}`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );

  return res.data;
};

/* ================= ADD ================= */
export const addSectionQuestion = async (section, data) => {
  const res = await http.post(
    `section_questions_api?action=add&section=${section}`,
    data
  );
  return res.data;
};

/* ================= DELETE ================= */
export const deleteSectionQuestion = async (section, id) => {
  const res = await http.post(
    `section_questions_api?action=delete&section=${section}&id=${id}`
  );
  return res.data;
};

/* ================= UPDATE ================= */
export const updateSectionQuestion = async (section, data) => {
  const res = await http.post(
    `section_questions_api?action=edit&section=${section}`,
    data
  );
  return res.data;
};